import { render, staticRenderFns } from "./ConfrontLoadList.vue?vue&type=template&id=676cfe08"
import script from "./ConfrontLoadList.vue?vue&type=script&lang=js"
export * from "./ConfrontLoadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports